import React, { memo } from 'react'
import tw from 'twin.macro'
import { ChevronLeftMinor, QuestionMarkMajor } from '@shopify/polaris-icons'
import { Typography, Button as MUIButton } from '@mui/material'
import { Button } from 'src/components/shared/Button'
import { Menu } from 'src/components/settings/Menu'
import { RemoteConfigBanner } from 'src/components/shared/RemoteConfigBanner'
import { RemoteConfigKey } from 'src/constants/remoteConfig'

interface Props {
  modalContainerRef: React.RefObject<HTMLDivElement>
  hideSettings?: boolean
  handleGetHelp: () => void
  onBack?: () => void
  handleBack: () => void
}

const ClientStepsHeaderComponent = ({
  modalContainerRef,
  hideSettings,
  handleGetHelp,
  onBack,
  handleBack,
}: Props) => {
  return (
    <div css={tw`[box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07)] w-full`}>
      <div css={tw`bg-shades-0 h-16 p-4 top-0 w-full flex items-center justify-between`}>
        <MUIButton
          variant="contained"
          color="secondary"
          onClick={onBack || handleBack}
          css={tw`bg-shades-100 hover:bg-gray-200 h-[42px]`}
          data-testid="header-nav-dashboard-btn"
        >
          <div css={tw`items-center flex flex-row`}>
            <ChevronLeftMinor width={20} />
            <Typography css={tw`text-shades-1000 [font-weight: 600]`}>Dashboard</Typography>
          </div>
        </MUIButton>
        {!hideSettings && (
          <div css={tw`flex-row flex gap-2`}>
            <Button
              className={tw`w-[120px] px-3`}
              rightIcon={<QuestionMarkMajor css={tw`fill-primary-500`} width={20} height={20} />}
              onClick={handleGetHelp}
              color="light"
              size="medium"
              data-testid="header-help-open-btn"
            >
              Get Help
            </Button>
            <Menu flow="client" variant="light" modalContainerRef={modalContainerRef} />
          </div>
        )}
      </div>
      <RemoteConfigBanner configKey={RemoteConfigKey.ClientBanner} className={tw`rounded-none`} />
    </div>
  )
}

export const ClientStepsHeader = memo(ClientStepsHeaderComponent)
